import { STORAGE_KEYS } from "@/constants";

const isBrowser = () => typeof window !== "undefined";

export const getStoredCartSessionId = () => {
  if (!isBrowser()) {
    return null;
  }

  return window.localStorage.getItem(STORAGE_KEYS.CART_SESSION_ID);
};

export const setStoredCartSessionId = (value: string | null) => {
  if (!isBrowser()) {
    return;
  }

  if (!value) {
    window.localStorage.removeItem(STORAGE_KEYS.CART_SESSION_ID);
    return;
  }

  window.localStorage.setItem(STORAGE_KEYS.CART_SESSION_ID, value);
};
